import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pricingModelFullName'
})
export class PricingModelFullNamePipe implements PipeTransform {
  transform(modelId: string | undefined, modelList: any[]): string {
    if (!modelId || !modelList) return '';
    
    const match = modelList.find(p => p.id === modelId);
    return match ? match.name : '';
  }
}
